import { FieldGroup } from '@clio/questionnaire-builder';
import { snakeCase } from 'lodash';
import { PartialQuestion, QuestionOption } from './QuestionnaireAutoGeneration';

export const createQuestionsFromFieldGroup = (
  fieldGroup: FieldGroup,
  questionnaireId: string,
): PartialQuestion[] => {
  // Sort by sort_order: the fields object's key order is unreliable because JS
  // reorders integer-like keys (e.g. "1","2","3"), scrambling numeric fields.
  const orderedFields = [...Object.values(fieldGroup.fields)].sort(
    (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0),
  );
  return orderedFields.map((field, index) => {
    const combinedNormalizedField = `${fieldGroup.normalized_field_group}.${field.normalized_field}`;
    const altered_by_AI = snakeCase(field.name) != field.normalized_field;
    const question: PartialQuestion = {
      title: field.name,
      external_question_identifier: field.normalized_field,
      altered_by_AI: altered_by_AI,
      description: field.hint ?? '',
      question_type: field.type,
      // Explicit display_order so the service preserves it instead of assigning
      // one (its tied-order tiebreaker would reorder them).
      display_order: index,
      question_options_attributes: [],
      question_mappings_attributes: [
        {
          questionnaire_id: parseInt(questionnaireId),
          external_field_identifier: combinedNormalizedField,
        },
      ],
      is_required: false,
    };

    if (
      question.question_type === 'QuestionMultipleChoiceSingle' ||
      question.question_type === 'QuestionMultipleChoiceMulti'
    ) {
      const questionOptions: QuestionOption[] =
        field.multiple_choice_options.map((option) => {
          return {
            label: option.label,
            value: option.value,
            question_option_type: 'QuestionOptionStatic',
            question_option_mappings_attributes: [
              {
                // external_field_identifier: String(option.value),
                external_field_identifier: `templatetags_attributemultiplechoiceoption__id__${option.id}`,
              },
            ],
          };
        });

      question.question_options_attributes = questionOptions;
    }

    return question;
  });
};
